<script setup lang="ts">
import { AppButton, AppTypography } from '@/components';

const props = withDefaults(
  defineProps<{
    jobTitle: string;
    subtitle?: string;
    description?: string;

    showButton?: boolean;
    buttonLabel?: string;
    backButtonLabel?: string;
    showDeleteButton?: boolean;
    deleteButtonLabel?: string;
    buttonColor?: string;
    showCancelButton?: boolean;
    loading?: boolean;
    isEdit?: boolean;
    isDraft?: boolean;
    draftButtonLabel?: string;
    isPublished?: boolean;
    isCreateJob?: boolean;
    saveButtonLabel?: string;
  }>(),
  {
    subtitle: '',
    description: '',
    showCancelButton: false,
    isEdit: false,
    showButton: false,
    buttonLabel: 'Save',
    backButtonLabel: 'Back',
    showDeleteButton: false,
    deleteButtonLabel: 'Delete',
    buttonColor: 'primary',
    loading: false,
    isDraft: false,
    draftButtonLabel: 'Draft',
    isPublished: false,
    isCreateJob: false,
  }
);

const emits = defineEmits<{
  (e: 'submit'): void;
  (e: 'back'): void;
  (e: 'draft') : void;
  (e: 'delete') : void;
  (e: 'publish') : void;
}>();

const onClick = (): void => {
  emits('submit');
};

const backButton = (): void => {
  emits('back');
};

const deleteButton = (): void => {
  emits('delete');
};

const draftButton = (): void => {
  emits('draft');
};

const publishButton = (): void => {
  emits('publish');
};

</script>

<template>
  <div
    class="app-form-header d-flex flex-column"
    :class="{
      'align-end': !showButton,
    }"
  >
    <div class="app-form-header__header d-flex align-center justify-space-between">
      <div class="header-titles">
        <!-- <AppTypography type="title-1" class="app-form-header__title flex-grow-1">{{ title }}</AppTypography> -->
        <AppTypography v-if="subtitle" type="headline-1" class="app-form-header__subtitle" @click="onClick">
          {{ subtitle }}
        </AppTypography>
      </div>
      <div class="header-buttons d-flex align-end">
        <AppButton v-if="showCancelButton" variant="text" color="primary" class="app-form-header__btn" @click="backButton" type="button" style="color: #ff0000 !important;">
          {{ backButtonLabel }}
        </AppButton>
        <AppButton v-if="showDeleteButton && (isEdit || isDraft)" variant="text" color="primary" class="app-form-header__btn" @click="deleteButton" type="button" style="color: #ff0000 !important;">
          {{ deleteButtonLabel }}
        </AppButton>
        <AppButton v-if="( isCreateJob && (isDraft || !isEdit)  ) || (!isPublished && isEdit)" variant="text" :color="buttonColor" class="app-form-header__btn" @click="draftButton" type="button">
          {{ draftButtonLabel }}
        </AppButton>
        <AppButton
          v-if="showButton && (isEdit && isDraft) || (isEdit && isCreateJob) || isCreateJob"
          variant="text"
          :color="buttonColor"
          :disabled="loading"
          class="app-form-header__btn"
          @click="onClick"
        >{{ isEdit && !isDraft ? 'Edit' : saveButtonLabel || buttonLabel }} 
        </AppButton>
        <AppButton
          v-if="showButton"
          variant="text"
          :color="buttonColor"
          :disabled="loading"
          class="app-form-header__btn"
          @click="onClick"
        >{{ buttonLabel }} 
        </AppButton>
      </div>
    </div>
    <AppTypography
      v-if="description"
      type="subheadline-2"
      class="app-form-header__description"
      :class="{
        'mt-2': !showButton,
      }"
      >{{ description }}</AppTypography
    >
  </div>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/fonts';

.app-form-header {
  :deep(.v-btn) {
    .v-btn__content {
      @include fonts.font-headline-1;
      font-size: 20px;
    }
  }
}
.header-titles {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header-buttons {
  gap: 8px; /* space between buttons */
}
</style>
